module.exports = __webpack_public_path__ + "static/bg_message_2-f76cfd33eeb7ec3dccf4e02d3c7d095c.jpg";